import { useState, useEffect } from "react";
import { Card, Upload, Button, Input, Select, Switch, Row, Col, Form, message, Modal, Typography } from "antd";
import { UploadOutlined, EditOutlined } from "@ant-design/icons";
import { BASE_URL,TIMEZONE_MAP,currencyMap } from '../Components/Constant';
import ApiService from '../Components/apiService'; // Import ApiService class
import eventBus from '../Components/eventBus';
import { compose } from "@reduxjs/toolkit";
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';

const { Option } = Select;
const {Title} = Typography;



const OrganizationSetup = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [recId, setRecId] =  useState(null);
  const [fileList, setFileList] = useState({
    logo: [],
    loginPageImage: [],
    favicon: [],
  });
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const security = useSelector((state) => state.data.items[0]);


  const handlePreview = (url) => {
    setPreviewImage(url);
    setPreviewVisible(true);
  };

  const handleFileUpload = async (file, fieldName) => {
    return new Promise((resolve, reject) => {
      if (file.size > 25 * 1024) {
        message.error("File size must be less than 25KB!");
        return reject(false);
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        form.setFieldsValue({ [fieldName]: reader.result });

        setFileList((prev) => ({
          ...prev,
          [fieldName]: [
            { uid: Date.now(), name: file.name, status: "done", url: reader.result },
          ],
        }));
        message.success("Image uploaded successfully!"); // Show success message
        resolve(true);
      };
      reader.onerror = (error) => reject(error);
    });
  };

  const fetchOrgRecord = async () => {
    const orgId = Cookies.get('orgId');
    console.log('org iddd::',orgId);
    try {
      const apiService = new ApiService(
        `${BASE_URL}/org_infos/${orgId}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      console.log('resp for org info')

      setRecId(response?._id);
      
      if (form && response) {
        form.setFieldsValue({
          ...response,
          organizationName: response?.name,
          businessCategory: response?.category,
          primaryEmail: response?.contact_email,
          supportEmail: response?.supportEmail,
          phoneNumber: response?.phoneNumber,
          defaultLocale: response?.defaultLocale,
          defaultLanguage: response?.defaultLanguage,
          defaultTimezone: response?.defaultTimezone,
          currency:  response?.currency || "$",
          logo: response?.logo,
          loginPageImage: response?.loginPageImage,
          favicon: response?.favicon,
          themeSelection: response?.themeSelection,
          street: response?.address?.street || "",
          city: response?.address?.city || "",
          postalCode: response?.address?.postalCode || "",
          state: response?.address?.state || "",
          country: response?.address?.country || "",
          twoFactorAuth: response?.twoFactorAuth || false,
          apiAccess: response?.apiAccess || false,
          chat: response?.chat || false,
          utility: response?.utility || false,
          title: response?.title || "",
          gridView: response?.gridView || false,
        });
        setFileList({
          logo: response?.logo
            ? [{ uid: "-1", name: "logo.png", status: "done", url: response?.logo }]
            : [],
          loginPageImage: response?.loginPageImage
            ? [{ uid: "-2", name: "loginPageImage.png", status: "done", url: response?.loginPageImage }]
            : [],
          favicon: response?.favicon
            ? [{ uid: "-3", name: "favicon.png", status: "done", url: response?.favicon }]
            : [],
        });
      }
    } catch (error) {
      console.error("Error fetching organization record:", error);
      message.error("Failed to fetch organization record.");
    }
  };

  // Fetch organization record on component mount
  useEffect(() => {
    fetchOrgRecord();
  }, []);

    const handleSave = async (values) => {
      console.log('Form values on save:', values?.gridView); // Add this line
      
    setLoading(true);
    try {
      const address = {
        street: values?.street || "",
        city: values?.city || "",
        postalCode: values?.postalCode || "",
        state: values?.state || "",
        country: values?.country || "",
      };
  
      const metadata = {
        // Optional: Extract additional fields for metadata here
        // region: values.region || "",
        // plan: values.plan || "",
      };
  
      const body = {
        org_info: {
          name: values?.name,
          first_name: values?.first_name,
          last_name: values?.last_name,
          username: values?.username,
          category: values?.category,
          instance_url: values?.instance_url,
          api_key: values?.api_key,
          contact_email: values?.contact_email,
          status: values?.status,
          onboarded_at: values?.onboarded_at,
          deactivated_at: values?.deactivated_at,
          metadata: metadata,
          address: address,
          currency: values?.currency,
          logo: fileList?.logo?.length > 0 ? fileList?.logo[0]?.url : "",
          loginPageImage: fileList?.loginPageImage?.length > 0 ? fileList?.loginPageImage[0]?.url : "",
          favicon: fileList?.favicon?.length > 0 ? fileList?.favicon[0]?.url : "",
          twoFactorAuth: values?.twoFactorAuth || false,
          apiAccess: values?.apiAccess || false,
          defaultLocale:values?.defaultLocale,
          defaultLanguage:values?.defaultLanguage,
          defaultTimezone:values?.defaultTimezone,
          gridView: values?.gridView || false,
          agent: values?.agent || false,
          utility: values?.utility || false,
        }
      };

      console.log('payload::', body);
      
      const apiService = new ApiService(
        `${BASE_URL}/org_infos/${recId}`,
        { 'Content-Type': 'application/json' },
        'PUT',
        body
      );
  
      const response = await apiService.makeCall();
      console.log('response::', response);
      eventBus.emit("OrgSetupUpdate");
  
      if (response) {
        message.success("Settings saved successfully!");
        setIsEditable(false);
      }
  
    } catch (error) {
      console.error("Error saving settings:", error);
      message.error("Failed to save settings.");
    } finally {
      setLoading(false);
      fetchOrgRecord();
    }
  };
  

  return (
    <div>
  <div style={{ maxHeight: "700px", overflowY: "auto" }}>
  <div style={{ 
      position: "sticky", 
      top: 0, 
      background: "white", 
      zIndex: 10, 
      padding: "4px 0",
      borderBottom: "1px solid #ddd"
    }}>
      <Row justify="space-between" align="middle">
        <Title level={4}  style={{ margin: 0 }}>Organisation Setup</Title>
        {security?.system_settings?.organisation_setup?.edit && (
        <Button 
          type="primary" 
          icon={<EditOutlined />} 
          onClick={() => setIsEditable(true)} 
          disabled={isEditable}
        >
          Edit
        </Button>
        )}
      </Row>
    </div>

    <Form form={form} layout="vertical" onFinish={handleSave}>
      <Row gutter={[16, 16]}>
        
      <Row gutter={[16, 16]} style={{ width: "100%" }}>
        {/* General Information - Left Side */}
        <Col span={12}>
          <Card title={<Typography.Title level={5} style={{ margin: 0 }}>General Information</Typography.Title>}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <Form.Item label="Organisation Name" name="organizationName">
                  {isEditable ? (
                    <Input placeholder="Enter Organisation Name" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("organizationName") || "-"}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Business Category" name="businessCategory">
                  {isEditable ? (
                    <Input placeholder="Enter Business Category" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("businessCategory") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Primary Email" name="primaryEmail">
                  {isEditable ? (
                    <Input placeholder="Enter Primary Email" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("primaryEmail") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Support Email" name="supportEmail">
                  {isEditable ? (
                    <Input placeholder="Enter Support Email" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("supportEmail") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Phone Number" name="phoneNumber">
                  {isEditable ? (
                    <Input placeholder="Enter Phone Number" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("phoneNumber") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Address - Right Side */}
        <Col span={12}>
          <Card title={<Typography.Title level={4} style={{ margin: 0 }}>Address</Typography.Title>}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <Form.Item label="Street" name="street">
                  {isEditable ? (
                    <Input placeholder="Enter Street" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("street") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="City" name="city">
                  {isEditable ? (
                    <Input placeholder="Enter City" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("city") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Postal Code" name="postalCode">
                  {isEditable ? (
                    <Input placeholder="Enter Postal Code" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("postalCode") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="State" name="state">
                  {isEditable ? (
                    <Input placeholder="Enter State" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("state") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Country" name="country">
                  {isEditable ? (
                    <Input placeholder="Enter Country" />
                  ) : (
                    <Typography.Text>
                      <strong>{form.getFieldValue("country") || ""}</strong>
                    </Typography.Text>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>



        <Row gutter={[16, 16]} style={{ width: "100%" }}>
          {/* Left Column - Locale Settings */}
          <Col span={12}>
            <Card title={<Typography.Title level={4} style={{ margin: 0 }}>Locale Settings</Typography.Title>}>
              <Form.Item label="Default Locale" name="defaultLocale" initialValue="India">
                {isEditable ? (
                  <Select disabled={!isEditable}>
                    <Option value="India">India</Option>
                    <Option value="United States (US)">United States (US)</Option>
                    <Option value="United Kingdom (UK)">United Kingdom (UK)</Option>
                    <Option value="Canada">Canada</Option>
                  </Select>
                ) : (
                  <Typography.Text><strong>{form.getFieldValue("defaultLocale") || ""}</strong></Typography.Text>
                )}
              </Form.Item>

              <Form.Item label="Default Language" name="defaultLanguage" initialValue="English">
                {isEditable ? (
                  <Select disabled={!isEditable}>
                    <Option value="English">English</Option>
                    <Option value="French">French</Option>
                    <Option value="Spanish">Spanish</Option>
                  </Select>
                ) : (
                  <Typography.Text><strong>{form.getFieldValue("defaultLanguage") || ""}</strong></Typography.Text>
                )}
              </Form.Item>

              <Form.Item label="Default Timezone" name="defaultTimezone" initialValue="UTC">
                {isEditable ? (
                  <Select showSearch disabled={!isEditable}>
                    {Object.entries(TIMEZONE_MAP).map(([abbr, iana]) => (
                      <Option key={abbr} value={abbr}>
                        {`${iana} (${abbr})`}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <Typography.Text><strong>{form.getFieldValue("defaultTimezone") || "-"}</strong></Typography.Text>
                )}
              </Form.Item>

              <Form.Item label="Default Currency" name="currency" initialValue="US Dollar (USD)">
                {isEditable ? (
                  <Select disabled={!isEditable}>
                    {currencyMap.map((currency) => (
                      <Option key={currency._id} value={currency._id}>
                        {currency.Name}
                      </Option>
                    ))}

                  </Select>
                ) : (
                  <Typography.Text>
                    <strong>
                      {
                        currencyMap.find(c => c._id === form.getFieldValue("currency"))?.Name || "-"
                      }
                    </strong>
                  </Typography.Text>
                )}
              </Form.Item>
            </Card>
          </Col>

          {/* Right Column - Branding & UI */}
          <Col span={12}>
            <Card title={<Typography.Title level={4} style={{ margin: 0 }}>Branding & UI</Typography.Title>}>
              <Form.Item label="Logo" name="logo">
                {isEditable ? (
                  <Upload
                    accept="image/*"
                    listType="picture-card"
                    fileList={fileList.logo}
                    beforeUpload={(file) => handleFileUpload(file, "logo")}
                    onPreview={(file) => handlePreview(file.url)}
                    onRemove={() => setFileList({ ...fileList, logo: [] })}
                    showUploadList={{ showRemoveIcon: true }}
                  >
                    {fileList.logo.length === 0 && <UploadOutlined />}
                  </Upload>
                ) : (
                  fileList.logo.length > 0 && (
                    <img
                      src={fileList.logo[0].url}
                      alt="logo"
                      style={{ width: "100px", cursor: "pointer" }}
                      onClick={() => handlePreview(fileList.logo[0].url)}
                    />
                  )
                )}
              </Form.Item>

              <Form.Item label="Login Page Image" name="loginPageImage">
                {isEditable ? (
                  <Upload
                    accept="image/*"
                    listType="picture-card"
                    fileList={fileList.loginPageImage}
                    beforeUpload={(file) => handleFileUpload(file, "loginPageImage")}
                    onPreview={(file) => handlePreview(file.url)}
                    onRemove={() => setFileList({ ...fileList, loginPageImage: [] })}
                    showUploadList={{ showRemoveIcon: true }}
                  >
                    {fileList.loginPageImage.length === 0 && <UploadOutlined />}
                  </Upload>
                ) : (
                  fileList.loginPageImage.length > 0 && (
                    <img
                      src={fileList.loginPageImage[0].url}
                      alt="loginPageImage"
                      style={{ width: "100px", cursor: "pointer" }}
                      onClick={() => handlePreview(fileList.loginPageImage[0].url)}
                    />
                  )
                )}
              </Form.Item>

              <Form.Item label="Favicon" name="favicon">
                {isEditable ? (
                  <Upload
                    accept="image/*"
                    listType="picture-card"
                    fileList={fileList.favicon}
                    beforeUpload={(file) => handleFileUpload(file, "favicon")}
                    onPreview={(file) => handlePreview(file.url)}
                    onRemove={() => setFileList({ ...fileList, favicon: [] })}
                    showUploadList={{ showRemoveIcon: true }}
                  >
                    {fileList.favicon.length === 0 && <UploadOutlined />}
                  </Upload>
                ) : (
                  fileList.favicon.length > 0 && (
                    <img
                      src={fileList.favicon[0].url}
                      alt="favicon"
                      style={{ width: "50px", cursor: "pointer" }}
                      onClick={() => handlePreview(fileList.favicon[0].url)}
                    />
                  )
                )}
              </Form.Item>

              <Form.Item label="Theme Selection" name="themeSelection" initialValue="Light Theme">
                {isEditable ? (
                  <Select disabled={!isEditable}>
                    <Option value="Light Theme">Light Theme</Option>
                    <Option value="Dark Theme">Dark Theme</Option>
                  </Select>
                ) : (
                  <Typography.Text><strong>{form.getFieldValue("themeSelection") || "-"}</strong></Typography.Text>
                )}
              </Form.Item>

              <Form.Item label="Title" name="title">
                {isEditable ? (
                  <Input placeholder="Enter title" />
                ) : (
                  <Typography.Text><strong>{form.getFieldValue("title") || "-"}</strong></Typography.Text>
                )}
              </Form.Item>
            </Card>
          </Col>
        </Row>


        {/* Security & Authentication */}
        <Col span={24}>
          <Card title={<Typography.Title level={4} style={{ margin: 0 }}>Security & Authentication</Typography.Title>}>
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item label="Two-Factor Authentication" name="twoFactorAuth" valuePropName="checked">
                  <Switch disabled={!isEditable} checkedChildren="2FA Enabled" unCheckedChildren="2FA Disabled" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="API Access" name="apiAccess" valuePropName="checked">
                  <Switch disabled={!isEditable} checkedChildren="API Access Enabled" unCheckedChildren="API Access Disabled" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Utility & Grid View */}
        <Col span={24}>
          <Card title={<Typography.Title level={4} style={{ margin: 0 }}>Utility & Grid View</Typography.Title>}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Utility" name="utility" valuePropName="checked">
                  <Switch disabled={!isEditable} onChange={(e)=>console.log(e)} checkedChildren="Utility Enabled" unCheckedChildren="Utility Disabled" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Grid View" name="gridView" valuePropName="checked">
                  <Switch disabled={!isEditable} checkedChildren="Grid View Defaulted" unCheckedChildren="List View Defaulted" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>

        {/* Chat & Agent */}
        <Col span={24}>
          <Card title={<Typography.Title level={4} style={{ margin: 0 }}>Chat & Agent</Typography.Title>}>
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item label="Chat" name="chat" valuePropName="checked">
                  <Switch disabled={!isEditable} onChange={(e)=>console.log(e)} checkedChildren="Chat Enabled" unCheckedChildren="Chat Disabled" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item label="Agent" name="agent" valuePropName="checked">
                  <Switch disabled={!isEditable} onChange={(e)=>console.log(e)} checkedChildren="Agent Enabled" unCheckedChildren="Agent Disabled" />
                </Form.Item>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

      {isEditable && (
        <div style={{ 
          position: "sticky", 
          bottom: 0, 
          background: "white", 
          zIndex: 10, 
          padding: "16px 0",
          textAlign: "right",
          borderTop: "1px solid #ddd"
        }}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save Settings
          </Button>
          <Button style={{ marginLeft: 8 }} onClick={() => setIsEditable(false)}>
            Cancel
          </Button>
        </div>
      )}
    </Form>
  </div>

  <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        zIndex={1002}   // higher than sidebar
      >
        <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>

</div>

  );
};

export default OrganizationSetup;
